<p-dialog
  [(visible)]="isOpen"
  [modal]="true"
  [responsive]="true"
  [maximizable]="false"
  [appendTo]="'body'"
  [styleClass]="'contextMenuModal profileModal'"
  [closable]="false"
  [dismissableMask]="true"
  [baseZIndex]="10000"
  [closeOnEscape]="true"
  [style]="{'height':'830px','max-width':'1250px', 'width': '70%'}"
  [resizable]="false"
>
  <p-header>
    <div
      class="d-flex flex-row align-items-center justify-content-between profile-padding"
    >
      <h6 class="gfid-title" style="font-size: 15px; font-weight: bold">
        Config Administration
      </h6>
      <span
        *ngIf="showGroupName"
        style="font-size: 13px;color: gray;font-family: 'OpenSansLight';width: 71em;"
        >{{selectedAdminGroupName}}</span
      >

      <button
        type="button"
        (click)="closeModal()"
        class="d-flex flex-row close qma-text"
        style="border:none !important;opacity:1"
      >
        <img
          src="assets/Inbox/close_icon_u73.svg"
          style="opacity:1"
          alt="Close"
        />
      </button>
    </div>
  </p-header>

  <div class="gfid-body admin-gfid-padding">
    <ng-template #customLoadingTemplate>
      <div class="custom-class-loader">
        <div class="spinner-container">
          <img
            src="assets/qwyn/icons/spinner.gif"
            alt="Loading"
            class="loader"
          />
        </div>
      </div>
    </ng-template>
    <ngx-loading
      [show]="showSpinner"
      [config]="{ backdropBorderRadius: '3px' }"
      [template]="customLoadingTemplate"
    >
    </ngx-loading>
    <div class="w-80">
      <p-tabView
        id="profileTabs"
        class="adminview"
        #profileTabs
        (onChange)="onTabChange($event)"
        [styleClass]="'admin-tabview'"
        [scrollable]="false"
        [style]="{'padding':'1em 0em','width':'100%','max-width':'1150px','margin-left': '16px', overflow: 'hidden', 'position': 'relative'}"
        [activeIndex]="actTabIdx"
      >
        <p-tabPanel *ngIf="isDBAdmin" header="Config Admin" class="tab-heading">
          <div class="pe-2 tabMinHeight">
            <div class="row p-2">
              <div class="col-6">
                <label for="from" class="flex-grow label_font">Select Collection </label>
                <p-dropdown
                [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'"
                  placeholder="Select Collection"
                  [(ngModel)]="selectedCollection"
                  name="selectedCollection"
                  [options]="databaseCollection"
                  [ngClass]="{'signatureDropdown-open': isDropdownOpen}" (onShow)="isDropdownOpen = true"
                  (onHide)="isDropdownOpen = false"
                >
                </p-dropdown>
              </div>
              <div class="col-6">
                <input
                  type="text"
                  [(ngModel)]="documentId"
                  name="documentId"
                  placeholder="Enter Document ID"
                  class="w-50 t-box inp-txt-mng group-details-input-mng"
                  style="margin-left:12%;padding-top:2%;"
                />
              </div>
            </div>
            <div class="row p-2">
              <div class="col-12">
                <textarea
                  pInputTextarea
                  [(ngModel)]="document"
                  name='document'
                  class="document-viewer"
                ></textarea>
              </div>
            </div>
            <div class="row p-2">
              <div class="col-3">
                <button
                  type="button"
                  class="submit-button"
                  (click)="backup()"
                >
                  Backup
                </button>
              </div>
              <div class="col-3">
                <button
                  type="button"
                  class="submit-button"
                  (click)="search()"
                >
                  Search
                </button>
              </div>
              <div class="col-3">
                <button
                  type="button"
                  class="submit-button"
                  (click)="validate()"
                >
                  Validate</button
                ><br /><br />
              </div>
              <div class="col-3">
                <button
                  type="button"
                  class="submit-button"
                  (click)="update()"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Config Refresh" class="tab-heading">
          <div class="pe-2 tabMinHeight">
            <div class="row p-2">
              <!-- <div class="col-2"></div> -->
              <div class="col-7">
                <label for="from" class="flex-grow label_font">Select Collection </label>
                <p-dropdown
                [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'"
              placeholder="Select Collection"
              [(ngModel)]="selectedConfigCollection"
              name="selectedConfigCollection"
              [options]="configCollection"
              [ngClass]="{'signatureDropdown-open': isDropdownOpen}" (onShow)="isDropdownOpen = true"
                (onHide)="isDropdownOpen = false"
            >
                </p-dropdown>
              </div>
            </div>
            <div *ngIf="refreshReport" class="statusMessage">
              <div class="">
                <div *ngIf="displaySuccessMessage" class="display-success">
                  
                  {{refreshStatus}}
                  <img
                    src="assets/Inbox/close_icon_u73.svg"
                    alt="Close"
                    class="close-icon-green"
                  />
                </div>
                <div *ngIf="!displaySuccessMessage" class="display-fail">
                  
                  {{refreshStatus}}
                  <img
                    src="assets/Inbox/close_icon_u73.svg"
                    alt="Close"
                    class="close-icon-red"
                  />
                </div>
                <!-- <ag-grid-angular class="ag-theme-balham message-grid mailbox-grid-unique-class grid-style"
                [defaultColDef]="defaultColDef" [rowData]="refreshReport" [columnDefs]="columnDefs"
                [modules]="modules" [rowStyle]="rowStyle">
              </ag-grid-angular> -->
              </div>
              <div class="col-1"></div>
            </div>
          </div>
        </p-tabPanel>
        <div class="fix-footer">
            <button class="cancel-button" (click)="reset()">Reset</button>
            <button *ngIf="actTabIdx === 1" class="submit-button" (click)="refresh()" >Refresh</button>
        </div>
      </p-tabView>
    </div>
  </div>
  <p-toast></p-toast>
</p-dialog>
<!--for error message -->
<p-confirmDialog
  header="Confirm Action"
  width="425"
  rejectIcon="No"
  acceptIcon="No"
  [appendTo]="'body'"
>
</p-confirmDialog>
<p-dialog
  [(visible)]="displayError"
  [modal]="true"
  [responsive]="true"
  [maximizable]="false"
  [appendTo]="'body'"
  [styleClass]="'contextMenuModal successModal ModelClose'"
  [closable]="true"
  [dismissableMask]="true"
  [baseZIndex]="10000"
  [closeOnEscape]="true"
  [style]="{width: '30%'}"
>
  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between">
      <h6 class="success-title">Information</h6>
    </div>
  </p-header>
  <div class="success-msg">{{errMsg}}</div>
</p-dialog>
<!--for success message-->
<p-dialog
  [(visible)]="displaySuccess"
  [modal]="true"
  [responsive]="true"
  [maximizable]="false"
  [appendTo]="'body'"
  [styleClass]="'contextMenuModal successModal ModelClose'"
  [closable]="true"
  [dismissableMask]="true"
  [baseZIndex]="10000"
  [closeOnEscape]="true"
  [style]="{width: '30%'}"
>
  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between">
      <h6 class="success-title">Success Confirmation</h6>
    </div>
  </p-header>
  <div class="success-msg">{{successMessage}}</div>
</p-dialog>
